<app-dossier
  eyebrow="Dossier agent // Rapport final"
  [reference]="operation.value()?.codeName ?? null"
>
  <app-page-title
    title="Rapport final"
    [lede]="operation.value()?.statusCode === 'COMPLETE' ? 'L\'opération est terminée.' : null"
  />

  @if (notComplete()) {
    <app-state-panel
      kind="empty"
      title="Rapport en cours de rédaction"
      message="Le rapport final sera publié à la fin de l'opération."
    >
      <a class="button button--secondary" [routerLink]="['/operations', operationId()]"
        >Suivre l'opération</a
      >
    </app-state-panel>
  } @else if (notFound()) {
    <app-state-panel
      kind="error"
      title="Dossier introuvable"
      message="Ce dossier n'existe pas, ou il a été détruit."
    />
  } @else if (loadError(); as message) {
    <app-state-panel kind="error" title="Transmission impossible" [message]="message">
      <button
        class="button button--secondary"
        type="button"
        (click)="operation.reload(); eliminations.reload()"
      >
        Réessayer
      </button>
    </app-state-panel>
  } @else if (operation.hasValue() && eliminations.hasValue()) {
    <h2 class="section-label section-label--center">Classement final</h2>
    <app-podium [entries]="report()" />

    @if (self(); as self) {
      <section class="verdict" aria-label="Votre bilan">
        <p
          class="stamp stamp--round"
          [class.stamp--success]="self.statusCode === 'SUCCEEDED'"
          aria-hidden="true"
        >
          @switch (self.statusCode) {
            @case ('SUCCEEDED') {
              Mission<br />accomplie
            }
            @case ('ABORTED') {
              Mission<br />abandonnée
            }
            @default {
              Joueur<br />éliminé
            }
          }
        </p>
        <div class="verdict__who">
          <p class="verdict__name">{{ self.codeName }}</p>
          <p class="first-name verdict__first-name">{{ self.firstName }}</p>
          <p class="label accent">
            @switch (self.statusCode) {
              @case ('SUCCEEDED') {
                Vous avez remporté l'opération
              }
              @case ('ABORTED') {
                Vous avez abandonné · {{ self.rank }}e place
              }
              @default {
                Vous avez été éliminé · {{ self.rank }}e place
              }
            }
          </p>
        </div>
        @if (self.eliminatedBy; as hunter) {
          <div class="verdict__by">
            <div>
              <p class="label">Éliminé par</p>
              <p>{{ hunter }}</p>
            </div>
            <img src="/assets/crosshair.svg" alt="" />
          </div>
        }
      </section>
    }

    <h2 class="section-label">Classement complet</h2>
    <section class="card ranking-card" aria-label="Classement complet">
      <app-ranking-table
        [rows]="report()"
        lastColumn="eliminatedBy"
        [selfCodeName]="self()?.codeName ?? null"
      />
      <p class="stamp stamp--round stamp--success stamp--pinned" aria-hidden="true">
        Mission<br />terminée
      </p>
    </section>

    <div class="note">
      <img class="paperclip paperclip--small" src="/assets/paperclip.svg" alt="" />
      <p>Rapport archivé. Dossier classé.</p>
      <p class="accent">Fin de la mission.</p>
    </div>
  } @else {
    <app-state-panel kind="loading" title="Ouverture du rapport…" />
  }
</app-dossier>
